import { IAggregate } from "../../../types";

export const Alloy_Tolerance = 0.05;

export interface IGroupData {
  weight: IAggregate;
  suggestedValue: IAggregate;
  setPointValue: IAggregate;
  delta: number;
}

export interface IKPIRecordData {
  material: string;
  color: string;
  max: number;
  delta: number;
  deltaAbs: number;
  totalSuggested: number;
  totalReal: number;
  groups: Record<string, IGroupData>;
}

